import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CoreModule } from "@modules/core/core.module";
import { LeveragedTokenInfoAmountComponent } from "@modules/main/components/leveraged-tokens/amount-select-leveraged-info/leveraged-token-info-amount.component";

const components = [LeveragedTokenInfoAmountComponent];

@NgModule({
	imports: [CommonModule, CoreModule],
	declarations: [...components],
	exports: [...components]
})
export class LeveragedTokenInfoAmountModule {}
